import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Crown } from 'lucide-react';

interface PremiumModalProps {
  open: boolean;
  onClose: () => void;
  featureName: string;
  featureDescription?: string;
  requiredPlan?: 'basico' | 'profesional' | 'premium';
}

const PLAN_NAMES: Record<string, string> = {
  basico: 'Básico',
  profesional: 'Profesional',
  premium: 'Premium',
};

export function PremiumModal({
  open,
  onClose,
  featureName,
  featureDescription,
  requiredPlan = 'premium',
}: PremiumModalProps) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const planName = PLAN_NAMES[requiredPlan];

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader className="items-center text-center">
          <div className="w-16 h-16 rounded-full bg-gradient-to-br from-[#B8860B]/20 to-[#D4AF37]/20 flex items-center justify-center mx-auto mb-2">
            <Crown className="h-8 w-8 text-[#B8860B]" />
          </div>
          <DialogTitle className="text-xl">
            {t('premium.modalTitle', 'Función Premium')}
          </DialogTitle>
          <DialogDescription className="text-center pt-2 space-y-2">
            <span className="block font-semibold text-neutral-800 text-base">
              {featureName}
            </span>
            <span className="block text-neutral-500">
              {featureDescription ||
                t('premium.availableInPlan', {
                  plan: planName,
                  defaultValue: `Esta función está disponible en el plan ${planName}`,
                })}
            </span>
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex-col gap-2 sm:flex-col">
          <Button
            onClick={() => {
              onClose();
              navigate('/settings/subscription');
            }}
            className="w-full bg-[#B8860B] hover:bg-[#8B6914] text-white font-semibold"
          >
            {t('premium.viewPlans', 'Ver Planes y Actualizar')}
          </Button>
          <Button
            variant="ghost"
            onClick={onClose}
            className="w-full text-neutral-500"
          >
            {t('premium.close', 'Cerrar')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
